import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CSVExport } from "../../components/ui-component/table/CSVExport";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { formatTime, fTimestamp } from "../../../utils/formatTime";

export default function EventMoreDetails({
  data,
  rowData,
  headerName,
  userReport,
}) {
  const [exportData, setExportData] = useState([]);
  const userRole=localStorage.getItem('userRole')
  const columns = [
    {
      field: "name", // Logical field name for the column
      headerName: "Enquiry Name",
      width: 200,
      // sortable: true, // Enable sorting
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.first_name || ""} ${
          params.row?.enquiry_id?.last_name || ""
        }`, // Use direct API fields
      renderCell: (params) => {
        return (
          <div>
            <Button
              size="small"
              style={{ fontSize: "0.65rem" }}
              onClick={() =>
                window.open(
                  `/enquirydetails/${params?.row?.enquiry_id?.id}`,
                  "_blank"
                )
              }
            >
              {params.row?.enquiry_id?.first_name}{" "}
              {params.row?.enquiry_id?.last_name}
            </Button>
          </div>
        );
      },
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      headerAlign: "center",
      align: "center",
      headerClassName: "bold-header",
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.mobile_country_code}${
          params.row?.enquiry_id?.mobile || ""
        }`,

      renderCell: (params) => (
        <div>
         {params.row?.enquiry_id?.mobile_country_code}
      {userRole === "advisor" || userRole === "trainer"
        ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
        : params.row?.enquiry_id?.mobile}
        </div>
      ),
    },

    {
      field: "event",
      headerName: "Event Name",
      width: 500,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params?.row?.event_id?.campaign_name || "",
      renderCell: (params) => <div>{params?.row?.event_id?.campaign_name}</div>,
    },

    {
      field: "registered_by",
      headerName: "Registered By",
      width: 100,
      headerAlign: "center",
      align: "center",

      valueFormatter: (params) => params.value?.name || "",
      renderCell: (params) => (
        <div>
          {" "}
          {params?.row?.registered_by?.first_name}{" "}
          {params?.row?.registered_by?.last_name}
        </div>
      ),
    },
    {
      field: "registered_date",
      headerName: "Registered Date",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "registered_time",
      headerName: "Registered Time",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>{params?.row?.registered_time? formatTime(params?.row?.registered_time) :""}</div>
      ),
    },

    {
      field: "registration_status",
      headerName: "Registration Status",
      width: 150,
      headerAlign: "center",
      align: "center",
    },

    // {
    //   field: "attendance_status",
    //   headerName: "Attendance Status",
    //   width: 150,
    //   headerAlign: "center",
    //   align: "center",
    //   valueGetter: (params) => params?.row?.is_attended ,
    //   renderCell: (params) => <div>{params?.row?.is_attended}</div>,
    // },
    {
  field: "attendance_status",
  headerName: "Attendance Status",
  width: 150,
  headerAlign: "center",
  align: "center",
  valueGetter: (params) => params?.row?.is_attended === 1 ? "Attended" : "",
  renderCell: (params) => (
    <div>
      {params?.row?.is_attended === 1 ? "Attended" : ""}
    </div>
  ),
}
  ];

  // Export Data

  useEffect(() => {
    const exportData = data?.map((row) => ({
      name: row?.last_name
        ? `${row?.enquiry_id?.first_name} ${row?.enquiry_id?.last_name}`
        : row.enquiry_id?.first_name,
      mobile: row?.enquiry_id?.mobile,
      event: row?.event_id?.campaign_name || "",

      registered_by: `${row?.registered_by?.first_name || " "} ${
        row?.registered_by?.last_name || " "
      }`,
      registered_date: row?.registered_date || "",
      registered_time: row?.registered_time || "",
      registration_status: row?.registration_status || "",
    }));
    setExportData(exportData);
  }, [data]);
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h4">
            {rowData?.event_id?.campaign_name}
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} md={6} textAlign="start" container gap={3}>
          {userReport && (
            <Box display="flex" flexDirection="row">
              <Typography variant="h5">
                {" "}
                Event Registration Report Of {rowData?.user_name}{" "}
              </Typography>{" "}
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={6} textAlign="end">
          <CSVExport data={exportData} filename="EnquiryDetails.csv" />
        </Grid>

        <Grid item xs={12}>
          <DataGrid
            rows={data}
            columns={columns}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}
